module.exports = __webpack_public_path__ + "img/smaller-aspect-ratio-icon.d871338b.svg";